import { getUserRbacGroup } from "src/shared/utils/Global";
import { UserType } from "./interface";

export const showAgencyName = () => {
  const userRbacGroup = getUserRbacGroup();
  return (
    userRbacGroup.includes(UserType.FCU_ADMIN) ||
    userRbacGroup.includes(UserType.FCU_AGENT) ||
    userRbacGroup.includes(UserType.FCU_MANAGER)
  );
};
